import InfoModal from './InfoModal';
import styles from './OrdenDiaModal.module.css';

export default function OrdenDiaModal({ assembly, onClose }) {
  const items = assembly.orden_del_dia
    ? assembly.orden_del_dia.split('\n').map(l => l.replace(/^\d+\.\s*/, '').trim()).filter(Boolean)
    : [];
  return (
    <InfoModal title="Orden del día" icon="fa-list-check" color="#12b76a" onClose={onClose}>
      <p className={styles.intro}>
        Asamblea #{assembly.number_assembly} — {assembly.property?.name}
      </p>
      {items.length === 0 ? (
        <div className={styles.vacio}>
          <i className={`fas fa-info-circle ${styles.iconoVerde}`} />
          El orden del día aún no ha sido publicado.
        </div>
      ) : (
        <ol className={styles.lista}>
          {items.map((item, i) => (
            <li key={i} className={`${styles.item} ${i % 2 === 0 ? styles.itemConFondo : ''}`}>
              {item}
            </li>
          ))}
        </ol>
      )}
    </InfoModal>
  );
}
